import React, { useEffect, useState } from "react"
import ListWithIcon from "Components/UI/Molecules/Lists/ListWithIcon"
import PaperList from "Components/UI/Molecules/Papers/PaperList"
import SetState from "Components/Hooks/SetState"
import { interfaces } from "service/interfaces"
import Search from "Components/UI/Atoms/Search"
import EditContextProvider from 'Components/Hooks/ContextEdit'
import DialogEdit from "./Update"

const WafersContent = () => {
  const [concepts, setConcepts] = useState([])
  const [valueSearch, setValueSearch] = useState("")
  const [selectedConcept, setSelectedConcept] = useState(null)
  const [render, setRender] = useState(false)
  const [tipoOblea, setTipoOblea] = useState()
  const [ constants, setConstants ] = useState()

  const {
    state: editConcept,
    setOpen: setOpenEdit,
    setClose: setCloseEdit,
  } = SetState()

  const getConcepts = async () => {
    await interfaces.configInterface
      .listWafers()
      .then((res) => {
        setConcepts(res.data.wafers)
        setTipoOblea(res.data.OBLEA_TIPO)
        setConstants({
          puertas: res.data.PUERTAS,
          tracciones: res.data.TRACCIONES,
          transmisiones: res.data.TRANSMISIONES,
          combustibles: res.data.COMBUSTIBLES,
          turbos: res.data.TURBOS
        })
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const onChangeSearch = (e) => {
    setValueSearch(e.target.value.toLowerCase())
  }

  const search = (data) => {
    return data
      .filter((wafer) => {
        return wafer.oblea_rudac.toLowerCase().includes(valueSearch)
      })
      .sort((a, b) => 
        a.oblea_rudac.localeCompare(b.oblea_rudac, 'es', { sensitivity: 'base' })
      )
  }

  const onClickItem = (item) => {
    setSelectedConcept(item)
  }

  useEffect(() => {
    getConcepts()
  }, [render])

  return (
    <>
      <Search 
        onChange={onChangeSearch} 
        placeholder="Buscar" 
      />
      <PaperList
        children={
          <ListWithIcon
            data={search(concepts)}
            nameIncludes="oblea_rudac"
            selectedItem={selectedConcept?.id}
            onClickSelect={onClickItem}
            onClickEdit={setOpenEdit}
          />
        }
        height="500px"
        styles={{ marginBottom: "15px" }}
      />

      <EditContextProvider>
        <DialogEdit
          open={editConcept.open}
          selectedConcept={selectedConcept}
          handleClose={setCloseEdit}
          setSelectedConcept={setSelectedConcept}
          tipoOblea={tipoOblea}
          constants={constants}
          setRender={setRender}
          render={render}
        />
      </EditContextProvider>
    </>
  )
}

export default WafersContent
